const translations = {
  en: {
    like: {
      one: '# respect',
      other: '# respect',
    },
    reply: {
      one: '# reply',
      other: '# replies',
    },
  },
  pt: {
    like: {
      one: '# respeito',
      other: '# respeito',
    },
    reply: {
      one: '# resposta',
      other: '# respostas',
    },
  },
};

function pluralize(count, actionType, locale = 'en') {
  const dictioanary = translations[locale] || translations.en;
  const forms = dictioanary[actionType];

  const pr = new Intl.PluralRules(locale);
  const rule = pr.select(count);

  const template = forms[rule] || forms.other;
  return template.replace('#', count);
}

export default {
  pluralize
};
